import { useEffect, useState } from "react";
import { ReactComponent as Icon } from "../Icons/greaterthan.svg";
const ScrollTopButton = () => {


    const [showScrollButton, setShowScrollButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > window.innerHeight) {
                setShowScrollButton(true);
            } else {
                setShowScrollButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            {showScrollButton && <div className=" bottom-[2.6%] md:bottom-[22px] z-[149] w-fit fixed right-[40px]">
                <button
                    onClick={scrollToTop}
                    className="flex max-[450px]:h-[35px] max-[450px]:w-[35px] w-[45px] h-[45px] text-white rounded-full border-[1px] border-highlight bg-ctaorange hover:bg-btnhover publish-hover flex justify-center items-center"
                >
                    <Icon className="text-white rotate-[270deg] hover:text-white arrowicon" />
                </button>
            </div>}
        </>
    )

}
export default ScrollTopButton;